import React, { Component } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import Main from "../main";
import {
  Login,
  ForgotPassword,
  ForgotPasswordSuccess,
  ResetPassword,
  ResetPasswordSuccess,
  OktaSetToken
} from "../auth";

import utils from "../../utils";
import ChatAgentOverlay from "../../components/chat-agent/chat-agent-overlay";
import ChatAgentFAB from "../../components/chat-agent/ChatAgentFAB";
import hasAIPermission from "../../utils/auth/hasAIPermission";
import McpOAuth from "../auth/mcp-oauth";

const { getToken, setDefaultAuthHeader } = utils.auth;

class App extends Component {
  componentWillMount() {
    if (getToken()) {
      setDefaultAuthHeader();
    }
  }

  render() {
    const { history } = this.props;

    return (
      <Router history={history}>
        <Switch>
          <Route path="/oauth/interaction/:uid" exact component={McpOAuth} />
          <Route path="/oauth/authorize" exact component={McpOAuth} />
          <Route path="/login" exact component={Login} />
          <Route path="/forgot-password" exact component={ForgotPassword} />
          <Route
            path="/forgot-password-success"
            exact
            component={ForgotPasswordSuccess}
          />
          <Route path="/reset-password/:id" exact component={ResetPassword} />
          <Route
            path="/reset-password-success"
            exact
            component={ResetPasswordSuccess}
          />
          <Route path="/okta/setToken" exact component={OktaSetToken} />
          <AuthorizedRoute path="/" component={Main} />
        </Switch>
      </Router>
    );
  }
}

class AuthorizedRoute extends Component {
  render() {
    const { component: Component } = this.props;

    return (
      <Route
        render={(props) => {
          return getToken() ? (
            <>
              <Component {...props} />
              {/* Global Chat Agent - FAB shows on supported screens, Overlay when opened */}
              {hasAIPermission() && (
                <>
                  <ChatAgentFAB />
                  <ChatAgentOverlay />
                </>
              )}
            </>
          ) : (
            <Redirect to="/login" />
          );
        }}
      />
    );
  }
}

export default App;
